import React from 'react';
import { MenuItem } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';

interface TimeGrainMenuItemProps {    
  isChecked: boolean;
  key: React.Key;
  onClick: () => void;
  optionName: string;
  isSelected: boolean;
  menuStyle: React.CSSProperties;
  menuSelectedStyle: React.CSSProperties;
}

const TimeGrainMenuItem: React.FC<TimeGrainMenuItemProps> = ({
  isChecked,
  key,
  onClick,
  optionName,
  isSelected,
  menuStyle,
  menuSelectedStyle,
}) => {
  return (
    <div style={{ display: "flex" }} key={key}>
      <span
        style={{
          color: "rgb(211, 211, 211)",
          paddingLeft: "5px",
          paddingTop: "4px",
          position: "absolute",
        }}
      >
        {isChecked ? <IoMdCheckmark style={{ color: "#7c7979" }} /> : null}
      </span>
      <MenuItem
        onClick={onClick}
        sx={{
          ...menuStyle,
          width: "100%",
          ...(isSelected && menuSelectedStyle),
        }}
      >
        {optionName}
      </MenuItem>
    </div>
  );
};

export default TimeGrainMenuItem;
